<template>
  <div>
    <div style="padding: 15px 0 15px 92px;position: relative;">
      <img style="position: absolute; top: 5px;" src="../../../static/image/house.png" alt />
      <span style="position: absolute; left: 122px; top: 5px;color:#999999;">员工入口</span>
    </div>

    <div class="stuffEnter">
      <div class="top">
        <div class="topBox clearfix" @click="clickTo(1)">
          <div>
            <div class="left">
              <img src="../../../static/img/stuffEnter/email.png" alt="" />
            </div>
            <div class="right">
              <p>邮箱</p>
              <span>Mailbox</span>
            </div>
          </div>
        </div>
        <div class="topBox clearfix" @click="clickTo(2)">
          <div>
            <div class="left">
              <img src="../../../static/img/stuffEnter/oa.png" alt="" />
            </div>
            <div class="right">
              <p>办公</p>
              <span>BPM SYSTEM</span>
            </div>
          </div>
        </div>
        <div class="topBox clearfix" @click="clickTo(3)">
          <div>
            <div class="left">
              <img
                src="../../../static/img/stuffEnter/medicalNeteork.png"
                alt=""
              />
            </div>
            <div class="right">
              <p>微E检</p>
              <span>Network</span>
            </div>
          </div>
        </div>
      </div>
      <div class="top">
        <div class="topBox clearfix" @click="clickTo(4)">
          <div>
            <div class="left">
              <img src="../../../static/img/stuffEnter/education.png" alt="" />
            </div>
            <div class="right">
              <p>华晟学院</p>
              <span>Education</span>
            </div>
          </div>
        </div>
        <div class="topBox clearfix">
          <div>
            <div class="bgc">
              <img src="" alt="" />
            </div>
            <div class="right">
              <p style=""></p>
              <span></span>
            </div>
          </div>
        </div>
        <div class="topBox clearfix">
          <div>
            <div class="bgc">
              <img src="" alt="" />
            </div>
            <div class="right">
              <p></p>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {}
  },
  methods: {
    clickTo(index) {
      if (index === 1) {
        // window.open('https://mail.hwason.cn/owa/auth/logon.aspx')
        window.open('http://mail.jangho.com')
      }
      if (index === 2) {
        window.open('http://bpm.hwason.cn/BPMSite/login.aspx')
      }
      if (index === 3) {
        window.open('http://wehealth.hwason.cn/#/')
      }
      if (index === 4) {
        window.open('http://edu.hwason.cn/login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stuffEnter {
  height: 550px;
  background-color: #f2f2f2;
  padding: 50px 5% 0 5%;
  overflow: hidden;

  .navTop {
    padding: 0 8%;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #999999;
    color: #999999;
    span {
      padding: 0 6px;
    }
    img {
      vertical-align: middle;
    }
    .right {
      float: right;
      div {
        float: left;
        width: 110px;
        height: 100%;
        color: #000;
        text-align: center;
        cursor: pointer;
      }
      .activeColor {
        background-color: #0068b7;
        color: #fff;
      }
    }
  }

  .top {
    width: 100%;
    height: 275px;
    display: flex;
    justify-content: space-between;
    .topBox {
      width: 500px;
      height: 200px;
      float: left;
      background-color: #fff;
      padding: 38px 40px;
      box-sizing: border-box;
      box-shadow: 0 2px 3px #999;
      cursor: pointer;
      .left {
        float: left;
        img {
          width: 150px;
          height: 124px;
        }
      }
      .right {
        width: 192px;
        height: 128px;
        float: right;
        p {
          font-size: 36px;
          margin-bottom: 30px;
          color: #858585;
        }
        span {
          display: inline-block;
          font-size: 24px;
          color: #858585;
        }
      }
    }
  }
}
.bgc {
  width: 150px;
  height: 124px;
  background-color: #F2F2F2;
}
</style>



// WEBPACK FOOTER //
// src/components/website/stuffEnter.vue